// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> apartment-management-consultants-theme-homestead-milburn -> sonoran-reserve
// Generated: 2026-08-24T16:59:14.999Z
// Counts: 7 design, 40 content, 22 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.textMuted": {
    "cssVariable": "--vibe-color-text-muted",
    "overrideType": "VALUE",
    "value": "#303030",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sonoran Reserve, our <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">diverse floor plans</a> cater to every lifestyle. Our Tucson, AZ apartments offer a convenient location where you can enjoy a rich cultural tapestry, along with easy access to the University of Arizona, Tumamoc Hill, and the Tucson Museum of Art. Embrace a community where adventure meets comfort!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Sonoran Reserve in Tucson, AZ, your <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">perfect home</a> awaits, from cozy one-bedroom nooks to spacious four-bedroom retreats. Enjoy a vibrant community rich with <a href=\"https://www.sonoranreserveapts.com/amenities/\">amenities</a> like a refreshing pool, state-of-the-art fitness center, and a pet-friendly dog park. Experience the comfort and convenience of our Tucson, AZ apartments – your new adventure starts here!</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Life in Your Perfect Apartment Paradise</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feeguide.aim_code": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_aim_property_code"
  },
  "floor-plans-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 4 Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sonoran Reserve, our vibrant community harmonizes comfort and convenience. Indulge in one of our stunning one, two, three, or four-bedroom apartments in Tucson, AZ, rejuvenate at the pool, or challenge friends on the basketball court. With chic features and a <a href=\"https://www.sonoranreserveapts.com/pets/\">pet-friendly atmosphere</a>, life here is effortlessly fulfilling. Come enjoy your perfect sanctuary today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Lifestyle-Enhancing Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span>At Sonoran Reserve in Tucson, AZ, your lifestyle meets luxury with spacious one to four-bedroom <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">floor plans</a>. Dive into a world of <a href=\"https://www.sonoranreserveapts.com/amenities/\">amenities</a>, from a refreshing pool and inviting hot tub to a vibrant dog park and fitness center. Lease online today and elevate your living experience at our apartments near the University of Arizona!</span> <span> <span></span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sonoran Reserve, our <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">thoughtfully designed floor plans</a> cater to every lifestyle, offering one to four-bedroom options. Each spacious home invites comfort and style. Have questions? Our friendly leasing team is here to assist you. Reach out today to find your perfect apartment in Tucson, AZ!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach Out to Learn More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Sonoran Reserve, our diverse floor plans cater to every lifestyle. From cozy one-bedroom retreats to spacious four-bedroom havens, each of our Tucson, AZ apartments is designed with comfort and style in mind. Browse our available apartment homes and <a href=\"https://www.sonoranreserveapts.com/virtual-tour/\">envision your ideal living space</a> today!&nbsp;</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Sonoran Reserve in Tucson, AZ, our diverse floor plans cater to every lifestyle. From cozy one-bedroom retreats to spacious four-bedroom havens, each layout is designed with comfort and style in mind. Browse our <a href=\"https://www.sonoranreserveapts.com/virtual-tour/\">available apartment homes</a> and envision your ideal living space today!&nbsp;</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sonoran Reserve, <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">your ideal home awaits</a>! Choose from spacious one to four-bedroom floor plans, each designed for comfort and style. Enjoy inviting <a href=\"https://www.sonoranreserveapts.com/amenities/\">amenities,</a> like a sparkling pool, modern fitness center, <a href=\"https://www.sonoranreserveapts.com/pets/\">pet-friendly spaces</a>, and more. Picture yourself living here in one of our apartments for rent in Tucson, AZ, where luxury meets lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 4 Bedroom Apartments in Tucson , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sonoran Reserve</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideally Located in Tucson , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime. From Any Distance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sonoran Reserve, pets are welcome as part of the community. Our pet-friendly apartments in Tucson, AZ, make it easy to enjoy everyday living with your furry companion by your side. With <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">comfortable apartment homes</a> and <a href=\"https://www.sonoranreserveapts.com/amenities/\">nearby outdoor spaces</a> to explore, residents and their pets can enjoy a convenient and relaxed lifestyle. Contact our leasing team today to learn more about our pet policy and schedule a tour of our gated community near Tumamoc Hill.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <strong>Non-Refundable Pet Fee:</strong> &nbsp;$500 (one pet) | $800 (two pets)</p><p> <strong>Monthly Pet Rent:&nbsp;</strong>$30 (one pet) | $60 (two pets)</p><p> <strong>Limit:&nbsp;</strong> 2 pets per apartment home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sonoran Reserve, you can choose from spacious one to four-bedroom <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">floor plans tailored to your lifestyle</a>. Experience modern Tucson, AZ apartment living for yourself. Ready to find your perfect home? Schedule a tour today and see what our residents love about living here. Your new adventure awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Tour of Sonoran Reserve</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule A Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Sonoran Reserve in beautiful Tucson, AZ! Your interest is important to us, and a dedicated team member will connect with you shortly. With an array of thoughtfully designed floor plans, including one to four-bedroom options, your ideal home awaits at Sonoran Reserve.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Sonoran Reserve, where modern living meets desert charm. Choose from <a href=\"https://www.sonoranreserveapts.com/floor-plans/\">spacious one to four-bedroom floor plans</a> that cater to your lifestyle. Experience the vibrant community and beautiful surroundings at our rentals in Tucson, AZ. Take a virtual tour today and envision your new home in this stunning oasis!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Virtual Tour of Our Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Amenities"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Resident Login"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule A Tour"
      }
    }
  },
  "herocallouts.cta1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans/"
      }
    }
  },
  "petpolicy.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore All Amenities"
      }
    }
  },
  "herocallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour/"
      }
    }
  },
  "herocallouts.cta3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore Our Amenities"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities/"
      }
    }
  },
  "herocallouts.cta4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Browse The Gallery"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/gallery/"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f66a9-6e15-710c-b4db-d263b5ac4279.webp"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f778b-0a3d-77fc-9018-21a0c2f51d95.webp"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f66a9-6eef-7617-a4ab-6ae2ad4d89f0.webp"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f66a9-7ab4-7705-ae54-653a36c26a41.webp"
      }
    }
  },
  "parallaxbanner.primary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Visit"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "parallaxbanner.secondary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour"
      }
    }
  },
  "petpolicy.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f778b-0edc-73b8-94d5-6bfdfdbe620f.webp"
      }
    }
  },
  "socialconnect.image1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f778b-0edc-73b8-94d5-6edd1c3674b1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views."
      }
    }
  },
  "socialconnect.image2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f778b-0a3d-77fc-9018-21a0c2f51d95.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Billiard table and bar area in the apartment clubhouse lounge."
      }
    }
  },
  "socialconnect.image3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f66a9-6e15-710c-b4db-d263b5ac4279.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with bar, seating, and string lights overlooking city."
      }
    }
  },
  "socialconnect.image4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166453/019f66a9-6eef-7617-a4ab-6ae2ad4d89f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with plush seating, large tables, and contemporary chandeliers."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "lea-chatbot",
      "blockId": "lea-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
